import { UploadOutlined } from "@ant-design/icons";
import { Form, Button, Upload } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useValidate } from "@/hooks/importToolXSLX";
import { useUpload } from "@/hooks/useUpload";

import { useImportContext } from "./ImportContext";
import {
  formatValidationAlerts,
  formatInvalidHeadingsAlert,
} from "./uploadUtils";

const ValidateImport = ({ onChange, onSetAlerts, onSetFilePath }) => {
  const { t } = useTranslation();
  const { model, modelName, operation } = useImportContext();

  const { loading: isUploading, handleUpload } = useUpload();
  const { loading: isValidating, handleValidate } = useValidate();

  const validateFile = async ({ file, onSuccess, onError }) => {
    const filePath = await handleUpload({ file });

    if (!filePath) {
      onError();
      return;
    }

    const { status, data, errorMessage } = await handleValidate(
      model,
      filePath,
      operation
    );

    if (status === "success") {
      const { valid: validHeadings, invalid: invalidHeadings } = data;
      const alerts = formatValidationAlerts(validHeadings, invalidHeadings);
      onSetAlerts(alerts);
      onSetFilePath(filePath);
      onSuccess();
    } else {
      if (errorMessage) {
        const alert = formatInvalidHeadingsAlert(errorMessage);
        onSetAlerts(alert);
      }
      onError();
    }
  };

  return (
    <Upload
      data-testid="upload"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      type="file"
      multiple={false}
      maxCount={1}
      customRequest={validateFile}
      onChange={onChange}
    >
      <Form.Item
        label={t(`importTool:import.${operation}Form.label`, {
          model: modelName,
        })}
        style={{ marginBottom: 0 }}
      >
        <Button loading={isUploading || isValidating} icon={<UploadOutlined />}>
          {t("importTool:import.selectFile")}
        </Button>
      </Form.Item>
    </Upload>
  );
};

ValidateImport.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSetAlerts: PropTypes.func.isRequired,
  onSetFilePath: PropTypes.func.isRequired,
};

export default ValidateImport;
